/*
 * eslint-disable -- a marca de duas barras nao existe no design system, entao
 * o botao e as barras sao elementos nativos.
 */
/* eslint-disable @alice-health/w-button, @alice-health/w-helper */

import classNames from 'classnames'

/*
 * A marca de duas barras do handoff nao corresponde ao icMenuHamburger do
 * design system, que tem tres. Por isso o desenho fica aqui.
 */
const barClassName =
  'h-[1.5px] w-[14px] rounded-full bg-gl-color-shades-magenta-60 transition-transform lg:h-[2px] lg:w-[16px]'

/*
 * Com o menu aberto as duas barras se sobrepoem no centro do botao e giram para
 * formar o X, como em producao: la o mesmo par de barras de 16x2 em magenta-60
 * gira, em vez de dar lugar a um icone de fechar. Assim a cor e a espessura do
 * X sao as mesmas do hamburger.
 */
const openBarClassName =
  'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'

interface NavbarHamburgerProps {
  isOpen: boolean
  onToggle: () => void
}

const NavbarHamburger = ({ isOpen, onToggle }: NavbarHamburgerProps) => (
  <button
    type='button'
    data-testid='navbar-hamburger'
    aria-label='Abrir e fechar o menu'
    aria-expanded={isOpen}
    onClick={onToggle}
    /* 40px literais: `h-10`/`w-10` dariam 35px, porque o `rem` do projeto e 14px. */
    className='relative flex h-[40px] w-[40px] flex-col items-center justify-center gap-gl-spacing-01 transition-opacity hover:opacity-45'
  >
    <span
      className={classNames(
        barClassName,
        isOpen && `${openBarClassName} rotate-45`
      )}
    />

    <span
      className={classNames(
        barClassName,
        isOpen && `${openBarClassName} -rotate-45`
      )}
    />
  </button>
)

export { NavbarHamburger }
